module.exports = __webpack_public_path__ + "static/media/3_Prepare-Screw-Holes-Confirm-Sizing.4587c472.svg";